import { render } from "./TextSplit.vue?vue&type=template&id=110e62bc"
import script from "./TextSplit.vue?vue&type=script&lang=js"
export * from "./TextSplit.vue?vue&type=script&lang=js"

import "./TextSplit.vue?vue&type=style&index=0&id=110e62bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__